import { componentTokens } from './components';
import { scaleTokens } from './semantic';

export { colorTokens, scaleTokens } from './semantic';
export { componentTokens } from './components';

export const themeTokens = {
  ...scaleTokens,
  components: componentTokens,
};
